module.exports = __webpack_public_path__ + "img/logo.ffea65c2.png";